import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, CircularProgress } from '@mui/material';
import { LocalShipping as SupplierIcon } from '@mui/icons-material';
import ContactList from './ContactList';
import axiosInstance from '../../utils/axiosConfig';

const SupplierList: React.FC = () => {
  const [supplierCount, setSupplierCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSupplierCount();
  }, []);

  const fetchSupplierCount = async () => {
    try {
      const response = await axiosInstance.get('/contacts', {
        params: { type: 'supplier', page: 1, limit: 1 }
      });
      const count = response.data.pagination?.total || 0;
      setSupplierCount(count);
    } catch (error) {
      console.error('Error fetching supplier count:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
    }}>
      <Box sx={{ p: 2 }}>
        <Card sx={{
          mb: 3,
          background: 'linear-gradient(120deg, #00796b 0%, #009688 100%)',
          color: 'white',
          borderRadius: 2,
          boxShadow: '0 4px 12px rgba(0, 121, 107, 0.3)'
        }}>
          <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 2.5 }}>
            <SupplierIcon sx={{ fontSize: 48 }} />
            <Box>
              <Typography variant="h6" sx={{ mb: 0.5 }}>إجمالي الموردين</Typography>
              {loading ? (
                <CircularProgress size={24} sx={{ color: 'white' }} />
              ) : (
                <Typography variant="h3" sx={{ fontWeight: 'bold' }}>{supplierCount}</Typography>
              )}
            </Box>
          </CardContent>
        </Card>
        <ContactList defaultType="supplier" hideTypeFilter />
      </Box>
    </Box>
  );
};

export default SupplierList;